import {graphql} from 'gatsby';
import React, {memo} from 'react';

import PageElementGroup from '../components/page-element-group';

export const query = graphql `
	query SponsorsPage {
		allPagesJson(filter: {slug: {eq: "sponsors"}}) {
			nodes {
				...PageElementGroup
			}
		}
	}
`;

export default memo(
	/**
	 * @param {import("gatsby").PageProps<
	 *   import("../../tmp/graphql-types").SponsorsPageQuery,
	 *   {
	 *     hashState: number,
	 *     meta: import("../page-metadata").PageMetadata,
	 *   }
	 * >} props
	 * @returns {React.ReactElement} ...
	 */
	function SponsorsPage({data, pageContext: {hashState, meta}}) {
		return (
			<PageElementGroup
				name="main"
				nodes={data.allPagesJson.nodes}
				meta={meta}
				hashState={hashState}
			/>
		);
	}
);
